import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import Bg from "../Assets/LandingPage/background.webp";
import title from "../Assets/LandingPage/zenith.webp";
import { Link } from "react-router-dom";

export default function Title() {
  // Menginisialisasi library AOS (Animate On Scroll)
  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  // Memastikan AOS me-refresh setiap kali komponen di-render ulang
  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  return (
    <div className="w-full m-0">
      <div className="snap-y snap-mandatory relative mt-[-72px] h-screen lg:h-[1080px] w-screen bg-center bg-cover bg-fixed" style={{ backgroundImage: `url(${Bg})` }}>
        <div className="z-10 pt-10">
          {/* ----- Tampilan Desktop (Hanya muncul di layar medium ke atas) ----- */}
          <div className="hidden md:flex flex-col justify-center items-center">
            <img data-aos="fade-down" data-aos-offset="300" data-aos-duration="1000" data-aos-delay="0" className="relative w-[1300px] mt-[-200px] lg:mt-[-120px] mx-auto" id="trigger-landing" src={title} alt="Logo Zenith" />
            <div data-aos="fade-up" data-aos-duration="1000" className="flex justify-center space-x-4 mt-[-280px] z-20 relative">
              <Link
                to="https://docs.google.com/document/d/19INiHyk-ZZZKMCcVTf4EHlYTQs_-a_cL2G8CFYG8uGw/edit?usp=sharing"
                target="_blank"
                className="bg-white font-semibold py-6 px-12 rounded-lg shadow-xl shadow-lg hover:bg-gray-200 transition-colors duration-300"
                style={{ color: "#2B387D" }}
              >
                Documentations
              </Link>
              <Link to="/scoreboard" className="bg-white font-semibold py-6 px-12 rounded-lg shadow-xl shadow-lg hover:bg-gray-200 transition-colors duration-300" style={{ color: "#2B387D" }}>
                Scoreboard
              </Link>
            </div>
          </div>

          {/* ----- Tampilan Mobile (Hanya muncul di layar di bawah medium) ----- */}
          {/* Menambahkan 'w-full' dan menghapus 'mx-auto' dari kontainer ini */}
          <div className="md:hidden flex flex-col items-center pt-36 w-full">
            {/* Logo ZENITH - Menggunakan arbitrary value w-[200px] */}
            <img data-aos="fade-down" data-aos-offset="300" data-aos-duration="1000" data-aos-delay="0" className="relative w-[3500px] mb-2" id="trigger-landing" src={title} alt="Logo Zenith" />
            {/* Kontainer Tombol */}
            <div data-aos="fade-up" data-aos-duration="1000" className="flex justify-center space-x-4">
              <Link
                to="https://docs.google.com/document/d/19INiHyk-ZZZKMCcVTf4EHlYTQs_-a_cL2G8CFYG8uGw/edit?usp=sharing"
                target="_blank"
                className="bg-white font-semibold py-3 px-6 rounded-lg shadow-xl shadow-lg hover:bg-gray-200 transition-colors duration-300 text-sm"
                style={{ color: "#2B387D" }}
              >
                Documentations
              </Link>
              <Link to="/scoreboard" className="bg-white font-semibold py-3 px-6 rounded-lg shadow-xl shadow-lg hover:bg-gray-200 transition-colors duration-300 text-sm" style={{ color: "#2B387D" }}>
                Scoreboard
              </Link>
            </div>
          </div>
        </div>

        {/* Lapisan gradient untuk transisi visual */}
        <div
          className="absolute inset-x-0 bottom-0 h-48"
          style={{
            background: "linear-gradient(to top, #E9F6FF, rgba(233, 246, 255, 0))",
          }}
        ></div>
      </div>

      {/* Bagian "About Zenith" */}
      <div className="bg-[#E9F6FF] py-20 px-4 md:px-20 lg:py-32 text-center">
        <h2 className="text-4xl lg:text-5xl font-semibold mb-8 font-amiri" style={{ color: "#2B387D" }}>
          About Zenith
        </h2>
        <div className="max-w-4xl mx-auto text-lg leading-relaxed text-gray-700">
          <p>
            <span className="font-bold text-3xl" style={{ color: "#17CCCC" }}>
              Zenith
            </span>
            <span style={{ color: "#2B387D" }}>
              {" "}
              refers to the highest point in the sky directly above the observer, or metaphorically, the peak of success and achievement. This theme inspires us to pursue our highest potential, reminding us that true excellence comes from
              the continuous effort to keep moving forward.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
